"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgAddContractLogResponse = exports.MsgAddContractLog = exports.MsgCreateContractFileResponse = exports.MsgCreateContractFile = exports.protobufPackage = void 0;
/* eslint-disable */
var minimal_1 = require("protobufjs/minimal");
exports.protobufPackage = "firmachain.firmachain.contract";
var baseMsgCreateContractFile = {
    creator: "",
    fileHash: "",
    timeStamp: 0,
    ownerList: "",
    metaDataJsonString: "",
};
exports.MsgCreateContractFile = {
    encode: function (message, writer) {
        var e_1, _a;
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.fileHash !== "") {
            writer.uint32(18).string(message.fileHash);
        }
        if (message.timeStamp !== 0) {
            writer.uint32(24).uint64(message.timeStamp);
        }
        try {
            for (var _b = __values(message.ownerList), _c = _b.next(); !_c.done; _c = _b.next()) {
                var v = _c.value;
                writer.uint32(34).string(v);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (message.metaDataJsonString !== "") {
            writer.uint32(42).string(message.metaDataJsonString);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgCreateContractFile);
        message.ownerList = [];
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.fileHash = reader.string();
                    break;
                case 3:
                    message.timeStamp = longToNumber(reader.uint64());
                    break;
                case 4:
                    message.ownerList.push(reader.string());
                    break;
                case 5:
                    message.metaDataJsonString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var e_2, _a;
        var message = __assign({}, baseMsgCreateContractFile);
        message.ownerList = [];
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.fileHash !== undefined && object.fileHash !== null) {
            message.fileHash = String(object.fileHash);
        }
        else {
            message.fileHash = "";
        }
        if (object.timeStamp !== undefined && object.timeStamp !== null) {
            message.timeStamp = Number(object.timeStamp);
        }
        else {
            message.timeStamp = 0;
        }
        if (object.ownerList !== undefined && object.ownerList !== null) {
            try {
                for (var _b = __values(object.ownerList), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var e = _c.value;
                    message.ownerList.push(String(e));
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        if (object.metaDataJsonString !== undefined &&
            object.metaDataJsonString !== null) {
            message.metaDataJsonString = String(object.metaDataJsonString);
        }
        else {
            message.metaDataJsonString = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.fileHash !== undefined && (obj.fileHash = message.fileHash);
        message.timeStamp !== undefined && (obj.timeStamp = message.timeStamp);
        if (message.ownerList) {
            obj.ownerList = message.ownerList.map(function (e) { return e; });
        }
        else {
            obj.ownerList = [];
        }
        message.metaDataJsonString !== undefined &&
            (obj.metaDataJsonString = message.metaDataJsonString);
        return obj;
    },
    fromPartial: function (object) {
        var e_3, _a;
        var message = __assign({}, baseMsgCreateContractFile);
        message.ownerList = [];
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.fileHash !== undefined && object.fileHash !== null) {
            message.fileHash = object.fileHash;
        }
        else {
            message.fileHash = "";
        }
        if (object.timeStamp !== undefined && object.timeStamp !== null) {
            message.timeStamp = object.timeStamp;
        }
        else {
            message.timeStamp = 0;
        }
        if (object.ownerList !== undefined && object.ownerList !== null) {
            try {
                for (var _b = __values(object.ownerList), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var e = _c.value;
                    message.ownerList.push(e);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        if (object.metaDataJsonString !== undefined &&
            object.metaDataJsonString !== null) {
            message.metaDataJsonString = object.metaDataJsonString;
        }
        else {
            message.metaDataJsonString = "";
        }
        return message;
    },
};
var baseMsgCreateContractFileResponse = {};
exports.MsgCreateContractFileResponse = {
    encode: function (_, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgCreateContractFileResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (_) {
        var message = __assign({}, baseMsgCreateContractFileResponse);
        return message;
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    fromPartial: function (_) {
        var message = __assign({}, baseMsgCreateContractFileResponse);
        return message;
    },
};
var baseMsgAddContractLog = {
    creator: "",
    contractHash: "",
    timeStamp: 0,
    eventName: "",
    ownerAddress: "",
    jsonString: "",
};
exports.MsgAddContractLog = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.contractHash !== "") {
            writer.uint32(18).string(message.contractHash);
        }
        if (message.timeStamp !== 0) {
            writer.uint32(24).uint64(message.timeStamp);
        }
        if (message.eventName !== "") {
            writer.uint32(34).string(message.eventName);
        }
        if (message.ownerAddress !== "") {
            writer.uint32(42).string(message.ownerAddress);
        }
        if (message.jsonString !== "") {
            writer.uint32(50).string(message.jsonString);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgAddContractLog);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.contractHash = reader.string();
                    break;
                case 3:
                    message.timeStamp = longToNumber(reader.uint64());
                    break;
                case 4:
                    message.eventName = reader.string();
                    break;
                case 5:
                    message.ownerAddress = reader.string();
                    break;
                case 6:
                    message.jsonString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgAddContractLog);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.contractHash !== undefined && object.contractHash !== null) {
            message.contractHash = String(object.contractHash);
        }
        else {
            message.contractHash = "";
        }
        if (object.timeStamp !== undefined && object.timeStamp !== null) {
            message.timeStamp = Number(object.timeStamp);
        }
        else {
            message.timeStamp = 0;
        }
        if (object.eventName !== undefined && object.eventName !== null) {
            message.eventName = String(object.eventName);
        }
        else {
            message.eventName = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        if (object.jsonString !== undefined && object.jsonString !== null) {
            message.jsonString = String(object.jsonString);
        }
        else {
            message.jsonString = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.contractHash !== undefined &&
            (obj.contractHash = message.contractHash);
        message.timeStamp !== undefined && (obj.timeStamp = message.timeStamp);
        message.eventName !== undefined && (obj.eventName = message.eventName);
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        message.jsonString !== undefined && (obj.jsonString = message.jsonString);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgAddContractLog);
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.contractHash !== undefined && object.contractHash !== null) {
            message.contractHash = object.contractHash;
        }
        else {
            message.contractHash = "";
        }
        if (object.timeStamp !== undefined && object.timeStamp !== null) {
            message.timeStamp = object.timeStamp;
        }
        else {
            message.timeStamp = 0;
        }
        if (object.eventName !== undefined && object.eventName !== null) {
            message.eventName = object.eventName;
        }
        else {
            message.eventName = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        if (object.jsonString !== undefined && object.jsonString !== null) {
            message.jsonString = object.jsonString;
        }
        else {
            message.jsonString = "";
        }
        return message;
    },
};
var baseMsgAddContractLogResponse = { id: 0 };
exports.MsgAddContractLogResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgAddContractLogResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgAddContractLogResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgAddContractLogResponse);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        return message;
    },
};
var MsgClientImpl = /** @class */ (function () {
    function MsgClientImpl(rpc) {
        this.rpc = rpc;
    }
    MsgClientImpl.prototype.CreateContractFile = function (request) {
        var data = exports.MsgCreateContractFile.encode(request).finish();
        var promise = this.rpc.request("firmachain.firmachain.contract.Msg", "CreateContractFile", data);
        return promise.then(function (data) {
            return exports.MsgCreateContractFileResponse.decode(new minimal_1.Reader(data));
        });
    };
    MsgClientImpl.prototype.AddContractLog = function (request) {
        var data = exports.MsgAddContractLog.encode(request).finish();
        var promise = this.rpc.request("firmachain.firmachain.contract.Msg", "AddContractLog", data);
        return promise.then(function (data) {
            return exports.MsgAddContractLogResponse.decode(new minimal_1.Reader(data));
        });
    };
    return MsgClientImpl;
}());
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (function () {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
